import { FilterItemDto } from '@creditsights/api-ui-web';

export const getSectorDisplayName = (tagId: string, filterTags: FilterItemDto[] = [], depth = 0): string | null => {
  for (const tag of filterTags) {
    if (depth > 1) {
      return null;
    }

    if (tagId === tag.tagId) {
      return tag.displayName;
    }

    const childSector = getSectorDisplayName(tagId, tag.children || [], depth + 1);
    if (childSector) {
      return childSector;
    }
  }
  return null;
};
